import {
  SET_IS_LOADING,
  SET_LAST_PARAMS,
  SET_IS_POPUP_SHOW,
  SET_TICKERS,
  SET_SELECTED_TICKER,
  SET_HUBS,
  SET_DATA_PAGINATION,
  SET_IS_POPUP_SHOW_EDIT,
  SET_SELECTED_LOCATION,
  SET_PAGES,
  SET_APP_LINKS,
} from 'storeContext/actionsType/ticker'

import type {
  TickerType,
  TickerQueryType,
  TickerHubOptionType,
  TickerPageOptionType,
  TickerAppLinkType,
  TickerPaginationType,
} from 'utils/apiList/ticker'

export type TickerStateType = {
  isLoading: boolean
  lastParams: TickerQueryType
  isShowPopup: boolean
  tickers: TickerType[]
  selectedTicker: Partial<TickerType>
  hubs: TickerHubOptionType[]
  dataPagination: Partial<TickerPaginationType>
  isShowPopupEdit: boolean
  selectedLocation: Partial<TickerHubOptionType>
  pages: TickerPageOptionType[]
  appLinks: TickerAppLinkType[]
}

export type TickerActionType =
  | { type: typeof SET_IS_LOADING; payload: boolean }
  | { type: typeof SET_LAST_PARAMS; payload: TickerQueryType }
  | { type: typeof SET_IS_POPUP_SHOW; payload: boolean }
  | { type: typeof SET_TICKERS; payload: TickerType[] }
  | { type: typeof SET_SELECTED_TICKER; payload: Partial<TickerType> }
  | { type: typeof SET_HUBS; payload: TickerHubOptionType[] }
  | { type: typeof SET_DATA_PAGINATION; payload: Partial<TickerPaginationType> }
  | { type: typeof SET_IS_POPUP_SHOW_EDIT; payload: boolean }
  | { type: typeof SET_SELECTED_LOCATION; payload: Partial<TickerHubOptionType> }
  | { type: typeof SET_PAGES; payload: TickerPageOptionType[] }
  | { type: typeof SET_APP_LINKS; payload: TickerAppLinkType[] }

export const initialStateTicker: TickerStateType = {
  isLoading: false,
  lastParams: {},
  isShowPopup: false,
  tickers: [],
  selectedTicker: {},
  hubs: [],
  dataPagination: {},
  isShowPopupEdit: false,
  selectedLocation: {},
  pages: [],
  appLinks: [],
}

export default function ticker(
  state: TickerStateType = initialStateTicker,
  { type, payload }: TickerActionType,
): TickerStateType {
  switch (type) {
    case SET_IS_LOADING:
      return {
        ...state,
        isLoading: payload,
      }
    case SET_LAST_PARAMS:
      return {
        ...state,
        lastParams: payload,
      }
    case SET_IS_POPUP_SHOW:
      return {
        ...state,
        isShowPopup: payload,
      }
    case SET_TICKERS:
      return {
        ...state,
        tickers: payload,
      }
    case SET_SELECTED_TICKER:
      return {
        ...state,
        selectedTicker: payload,
      }
    case SET_HUBS:
      return {
        ...state,
        hubs: payload,
      }
    case SET_DATA_PAGINATION:
      return {
        ...state,
        dataPagination: payload,
      }
    case SET_IS_POPUP_SHOW_EDIT:
      return {
        ...state,
        isShowPopupEdit: payload,
      }
    case SET_SELECTED_LOCATION:
      return {
        ...state,
        selectedLocation: payload,
      }
    case SET_PAGES:
      return {
        ...state,
        pages: payload,
      }
    case SET_APP_LINKS:
      return {
        ...state,
        appLinks: payload,
      }
    default:
      return state
  }
}
